import StandFileList from "./stand-file-list";
import StandDropdownActions from "./stand-dropdown-actions";

const StandAction = {
	UploadDownload: StandFileList,
	Dropdown: StandDropdownActions
}

export default StandAction;